export default __webpack_public_path__ + "static/contabilidad-05c0f295add571c807ac095c51b9c0bc.png";